import { render } from "./clearDataModal.vue?vue&type=template&id=a2f7eb72"
import script from "./clearDataModal.vue?vue&type=script&lang=js"
export * from "./clearDataModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/weektodo/weektodo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__